module.exports = __webpack_public_path__ + "img/material-design.726d3fc2.png";